import { collection } from "firebase/firestore";
import { FireDB } from "../server/firebase-config";

export const packingsListsCollectionRef = collection(FireDB, 'packinglists');

export const companysCollectionRef = collection(FireDB, 'companys');

export const carsCollectionRef = collection(FireDB, 'cars');

